import type { ErrorLike } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { deselectQuotes, selectQuotes } from '@utils/queries/quotesSelection';

const useSelectBundle = () => {
  const { basketId } = useBasketContext();
  const setSnackbarError = useSnackbarError();
  const [select, { loading: isSelecting, error: selectError }] =
    useMutation(selectQuotes);
  const [deselect, { loading: isDeselecting, error: deselectError }] =
    useMutation(deselectQuotes);

  const handleSelection = async (
    { selectIds, deselectIds }: { selectIds: string[]; deselectIds: string[] },
    onComplete: () => void,
    onError: () => void
  ) => {
    try {
      await select({
        variables: {
          quoteInput: {
            basketId,
            quoteIds: selectIds,
          },
        },
      });

      await deselect({
        variables: {
          quoteInput: {
            basketId,
            quoteIds: deselectIds,
          },
        },
      });
      onComplete();
    } catch (error) {
      onError();
      setSnackbarError(error as ErrorLike);
    }
  };

  return {
    isLoading: isSelecting || isDeselecting,
    error: selectError || deselectError,
    handleSelection,
  };
};

export { useSelectBundle };
